<div class="tab-content" [class.loading]="isContentLoading">
  @if (isContentLoading) {
    <i class="fa-solid fa-spinner fa-spin tab-loading-spinner"></i>
  }
  @if (!isContentLoading && canViewAccountSettings) {
    <p class="double-margin-bottom">Manage your general Arpio account settings below.</p>
    <div class="margin-top flex gap-4 items-center">
      <h3 class="inline-heading">Account ID:</h3>
      <div>{{ accountService.accountId }}</div>
    </div>
    <div class="margin-top flex items-center gap-4 items-center">
      <h3 class="whitespace-nowrap">Account Name:</h3>
      @if (canEditAccountName) {
        <div class="full-width">
          <form class="flex-center-row full-width" [formGroup]="accountNameModel" (ngSubmit)="updateAccountName()">
            <input id="account-name" formControlName="name" class="arpio-input space full-width" focus-element />
            <button
              type="submit"
              busy-button
              [busy]="updatingAccountName"
              [done]="updatedAccountName"
              class="arpio-button margin-left"
              [disabled]="saveNameDisabled"
              data-cy="update-account-name-button"
            >
              UPDATE
            </button>
          </form>
        </div>
      } @else {
        <div>{{ accountDto?.name }}</div>
      }
    </div>
    @if (canDisplayEntitlementContent) {
      <div class="margin-top flex gap-4 items-center">
        <h3 class="inline-heading">Product Edition:</h3>
        <div>{{ accountService.productEdition }}</div>
      </div>
      @if (canViewLicenseCount) {
        <div class="margin-top">
          <div class="flex gap-4 items-center">
            <h3 class="inline-heading">License Count:</h3>
            @if (isOverLicensedBillableResourceCount) {
              Current consumption of {{ currentBillableResourceCount }} billable resources exceeds licensed count of
              {{ licencedBillableResourceCount }}.
            } @else {
              Consuming {{ currentBillableResourceCount }} of {{ licencedBillableResourceCount }} licensed billable
              resources.
            }
            @if (accountService.overageEnforcementEnabled) {
              <span>Overage enforcement is enabled.</span>
            }
          </div>
          @if (isLoadingReport) {
            <i class="fa-solid fa-spinner fa-spin"></i> Loading billable resources report...
          } @else {
            @if (this.reportRecordCountValue > 0) {
              Download the <a href="{{ billableResourceReportUrlCsv() }}"> report of billable resources</a>.
            }
          }
        </div>
      }
      @if (accountService.subscriptionExpired) {
        <div class="margin-top flex gap-4 items-center">
          <h3 class="inline-heading">Subscription Status:</h3>
          <div>
            Expired on {{ accountService.subscriptionExpiration | date: 'shortDate' }}. Click
            <a target="_blank" [href]="accountService.marketplaceUrl">here</a> to purchase a new subscription.
          </div>
        </div>
      } @else {
        <div class="margin-top flex gap-4 items-center">
          <h3 class="inline-heading">Subscription Expires:</h3>
          <div>{{ accountService.subscriptionExpiration | date: 'shortDate' }}</div>
        </div>
      }
    }
  }
</div>
